import {apolloClientService} from '../../../../services/apollo-client';
export const energyconsumptionService = {
    getDropdownData,
    usageGraphData,
    getBillingHistoryDetails,usageMailStatus,usageMail
};

 function getDropdownData(groupCode,languageCode) {
   let APIquery= `{getDropdownData(input:{groupCode:"` +groupCode +`",languageCode:"`+languageCode+`"})}`;
   return apolloClientService.ApolloClientgqls(APIquery); 
}

 function usageGraphData(saId,accountId,startDate,endDate,displayMode, additionalIdentifiers){  
  if(additionalIdentifiers && Array.isArray(additionalIdentifiers))
    additionalIdentifiers = JSON.stringify(additionalIdentifiers).replace(/"([^"]+)":/g, "$1:");
  else
    additionalIdentifiers = `[]`
  let action = displayMode === "D2BD" ? "Daily" : displayMode === "D2BM" ? "Monthly" : "";
  const APIquery=
  `{ getUsageTrends(input: {displayMode: "`+displayMode+`",startDate:"`+startDate+`",endDate:"`+endDate+`",
  additionalIdentifiers: ` + additionalIdentifiers + `,action:"`+action+`"
 }) { 
 usageQuantity { 
     intervalName 
     intervalShortName 
     intervalDateTime 
     quantity
     amount
     noData
     usageDate
 } 
 usageUnit 
}
}`
  const headers={
    saId: saId,
    accountId:accountId
    }
    return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only"); 
}

async function getBillingHistoryDetails(dateInput,accountID,startDate){
  let APIquery =
    `{getBillPayHistory(input:{
    endDate:"` +
    dateInput +
    `",
    startDate:"` +
    startDate +
    `",
     accountId:"` +
     accountID +
     `"}){financialBillHistory}}`;
    let headers={
      accountId: accountID,
    }
    return await apolloClientService.ApolloClientgqlsUsage(APIquery,headers);
}
function usageMail(startDate,endDate,accountId,saId,displayMode,meterNumber,primaryMail, additionalIdentifiers){
  if(additionalIdentifiers && Array.isArray(additionalIdentifiers))
    additionalIdentifiers = JSON.stringify(additionalIdentifiers).replace(/"([^"]+)":/g, "$1:");
  else
    additionalIdentifiers = `[]`
  let APIquery = `{
    sendUsageReportEmail(input:{
    startDate:"`+startDate+`",
    endDate:"`+endDate+`",
    mode:"`+displayMode+`",
    meterNumber:"`+meterNumber+`",
    primaryIdentifier:"`+primaryMail+`",
    additionalIdentifiers: `+ additionalIdentifiers +` 
    }){
    status
    message
   }
    }`
    let headers={
      saId: saId,
      accountId:accountId,
      }
      return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only"); 

}

function usageMailStatus(accountId,saId){
  let APIquery=`{
    getEmailStatus {
        status
        response
    }
}`
let headers={
  saId: saId,
  accountId:accountId,
  }
return  apolloClientService.ApolloClientgqlsUsage(APIquery,headers,"network-only"); 
}